import NUIAlert from '@/components/Alert/Alert'
import { IConfigSeller } from '@/models/configSeller'
import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { blobToBase64 } from '@/utils/blobToBase64.util'
import { currencyFormat } from '@/utils/currencyFormat'
import { Typography } from '@mui/material'
import { Radio, RadioGroup, Button, cn, Switch } from '@nextui-org/react'
import { fromImage } from 'imtool'
import { enqueueSnackbar } from 'notistack'
import React, { useCallback, useEffect, useState, CSSProperties } from 'react'
import { Accept, useDropzone } from 'react-dropzone'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { currencyTextFormat } from '@/utils/currencyTextFormat'

const Extras = () => {
  const { ctx, saveCtx } = useTradeinContext()
  console.log('ctx => ', ctx)
  console.log('ctx.tradein => ctx.tradein.isBatteryHealthy', ctx.tradein.isBatteryHealthy)
  console.log('ctx.tradein => ctx.tradein.isExtraControl', ctx.tradein.isExtraControl)
  const userState = useSelector((store: IAppStore) => store.user)
  const [discounts, setDiscounts] = useState<{ haveCharger: boolean, isExtraControl: boolean }>({ haveCharger: true, isExtraControl: true })
  const [data, setData] = useState<{ loading: boolean, imagen: string }>({ loading: false, imagen: '' })
  const { slug, id } = useParams()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'
  const [extraControls, setExtraControls] = useState({ willDeliver: null as null | 'yes' | 'no', quantity: 0 })

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const validFiles = acceptedFiles.filter(file =>
      ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)
    )
    console.log('🚀 ~ onDrop ~ validFiles:', validFiles)

    // Asegúrate de que 'files' es de tipo 'File[]'
    saveCtx({
      ...ctx,
      files: [...validFiles]
    })
  }, [ctx, saveCtx])

  const accept: Accept = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg']
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    maxFiles: 1
  })

  const removeFile = (file: File, event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    saveCtx({
      ...ctx,
      files: ctx.files.filter(f => f !== file)
    })
  }

  const uploadImage = async () => {
    let _discount = ctx.tradein.discount_amount
    let newControlsDiscount = 'n/a'
    let reciviedControls = ctx.tradein.extraControlsQuoted ?? 0
    for (const element of ctx.files) {
      if (element.nameFile === undefined) {
        delete element.preview
        element.blob = await fromImage(element).then((tool: any) => tool.thumbnail(800, false).toBlob())
        element.base64 = await blobToBase64(element.blob)
        delete element.blob
      }
    }
    console.log('🚀 ~ forawait ~ ctx.files:', ctx.files)
    setData({ ...data, loading: true })

    const newDiscount = getNewMontoExtraControl()
    const quoted = getMontoExtraControl()
    console.log('newDiscount', newDiscount)
    console.log('quoted', quoted)
    console.log('extraControls => ', extraControls)
    if (!extraControls.willDeliver || extraControls.willDeliver === 'no') {
      reciviedControls = extraControls.quantity ? Number(extraControls.quantity) : 0
      if (newDiscount >= quoted) {
        console.log('newDiscount >= quoted', newDiscount >= quoted)
        newControlsDiscount = `+ ${newDiscount - quoted}`
        console.log('discount original', _discount)
        _discount = _discount + (newDiscount - quoted)
        console.log(_discount)
      } else if (newDiscount < quoted) {
        newControlsDiscount = `- ${quoted - newDiscount}`
        _discount = _discount - (quoted - newDiscount)
      }
    }
    console.log('receivedControls', reciviedControls)
    console.log('newControlsDiscount', newControlsDiscount)
    console.log('_discount', _discount)
    setData({ ...data, loading: false })
    webApiService.saveFiles({ id, store_user: String(userState.id), files: ctx.files, seller: slug, extraControl: 'si', isExtraControl: Number(discounts.isExtraControl), discount: _discount, haveCharger: discounts.haveCharger, newControlsDiscount, reciviedControls }).then(() => {
      enqueueSnackbar(ctx.files.length > 0 ? 'Imagen cargada con exito' : 'Información cargada con exito', { variant: 'success' })
      saveCtx({ ...ctx, files: [], reload: true })
      setData({ ...data, loading: false })
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData({ ...data, loading: false })
    })
  }

  const loadData = () => {
    // if (ctx.tradein.brand === 'Apple' && ctx.tradein.sbu === 'Smartphone' && ctx.tradein.isExtraControl === 1) return
    setData({ ...data, loading: true })
    webApiService.getFiles(String(id)).then((res: any) => {
      setData({ loading: false, imagen: res.data.find((item: any) => item.name.includes('extraControl'))?.name ?? null })
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData({ ...data, loading: false })
    })
  }

  const getMontoExtraControl : () => number = () => {
    const _discount = Number(ctx.tradein.extraControlsQuoted) * Number(import.meta.env.VITE_EXTRA_CONSOLA)
    return _discount
  }

  const getNewMontoExtraControl : () => number = () => {
    const _discount = Number(extraControls.quantity) * Number(import.meta.env.VITE_EXTRA_CONSOLA)
    return _discount
  }

  const getInfoNewAmount = () => {
    const newDiscount = getNewMontoExtraControl()
    const quoted = getMontoExtraControl()
    if (newDiscount >= quoted) {
      return `aumento de ${currencyFormat(newDiscount - quoted, import.meta.env.VITE_COUNTRY)}`
    } else if (newDiscount < quoted) {
      return `descuento de ${currencyFormat(quoted - newDiscount, import.meta.env.VITE_COUNTRY)}`
    }
  }

  useEffect(() => {
    if (ctx.tradein.isExtraControl !== null && ctx.tradein.sbu !== 'Smartwatch') loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.tradein.isExtraControl])

  return (
    <div className='bg-white rounded-lg shadow-lg p-4 h-full'>
      {
      ctx.tradein.id_status === 1 || (isSamsungPeru && ctx.formAnswers.length === 0)
        ? (
          <div>
            <Typography variant='h6' component='div' gutterBottom style={{ borderBottom: '1px solid #f3f1f1', fontSize: '18px' }}>
              Aumento
            </Typography>
            <NUIAlert type='info'>Se requiere el resultado de la evaluación técnica.</NUIAlert>
          </div>
          )
        : ctx.tradein.recalculate === '1' && ctx.tradein.wasRecalculated === null
          ? (
            <div>
              <Typography variant='h6' component='div' gutterBottom style={{ borderBottom: '1px solid #f3f1f1', fontSize: '18px' }}>
                Aumento
              </Typography>
              <NUIAlert type='info'>Se requiere recalcular el dispositivo.</NUIAlert>
            </div>
            )
          : (
            <div className='h-full'>

              <div className='grid grid-cols-2 border-b-1 mb-2 '>
                <div><h6 className=' font-bold text-xl pb-2'>Controles extra</h6></div>
                {
                !extraControls.willDeliver || extraControls.willDeliver === 'yes'
                  ? <div hidden={!!ctx.tradein.extraControlsReceived || ctx.tradein.extraControlsReceived === 0} className='text-end font-black text-lg'>Suma de controles cotizados: <span className='text-primary'>{currencyFormat(getMontoExtraControl(), import.meta.env.VITE_COUNTRY)}</span></div>
                  : <div hidden={!!ctx.tradein.extraControlsReceived || ctx.tradein.extraControlsReceived === 0} className='text-end font-black text-lg'>Nuevo monto a sumar: <span className='text-primary'>{currencyFormat(getNewMontoExtraControl(), import.meta.env.VITE_COUNTRY)}</span></div>
                }
                <div hidden={!ctx.tradein.extraControlsReceived && ctx.tradein.extraControlsReceived !== 0} className='text-end font-black text-lg'>Monto:  <span className='text-primary'>{currencyTextFormat(ctx.tradein.extraControlsValue, import.meta.env.VITE_COUNTRY)}</span></div>
              </div>
              {
        ctx.tradein.haveCharger === null && (ctx.tradein.sbu === 'Notebook' || ctx.tradein.sbu === 'Smartwatch')
          ? (
            <Switch
              isSelected={!discounts.haveCharger} onValueChange={(value) => setDiscounts({ ...discounts, haveCharger: !value })}
              classNames={{
                base: cn(
                  'inline-flex flex-row-reverse w-full max-w-full bg-content1 hover:bg-content2 items-center',
                  'justify-between cursor-pointer rounded-lg gap-2 p-4 border-2 border-transparent',
                  'data-[selected=true]:border-primary'
                ),
                wrapper: 'p-0 h-4 overflow-visible',
                thumb: cn('w-6 h-6 border-2 shadow-lg',
                  'group-data-[hover=true]:border-primary',
                  // selected
                  'group-data-[selected=true]:ml-6',
                  // pressed
                  'group-data-[pressed=true]:w-7',
                  'group-data-[selected]:group-data-[pressed]:ml-4'
                )
              }}
            >
              <div className='flex flex-col gap-1'>
                <p className='text-medium'>¿Se entrega dispositivo sin cargador?</p>
              </div>
            </Switch>
            )
          : null
      }
              <span />
              {
        ctx.tradein.isExtraControl === null && ctx.tradein.sbu !== 'Smartwatch'
          ? (
            <div className='py-2'>

              {/* Nueva pregunta: Controles extra */}
              <div
                className='border p-4 rounded-md mb-4'
              >
                <h4 className='text-lg mb-3'>¿Se entregan funcionando los controles extra ({ctx.tradein.extraControlsQuoted}) que se cotizarón?</h4>
                <RadioGroup
                  orientation='horizontal'
                  value={extraControls.willDeliver ?? ''}
                  onChange={(e) => setExtraControls({ ...extraControls, willDeliver: e.target.value as 'yes' | 'no' })}
                >
                  <Radio value='yes' style={{ '--seller-color': `${configSeller.config.color}` } as CSSProperties} classNames={{ control: 'bg-black', wrapper: 'group-data-[selected=true]:border-black' }}>
                    Sí
                  </Radio>
                  <Radio value='no' style={{ '--seller-color': `${configSeller.config.color}` } as CSSProperties} classNames={{ control: 'bg-black', wrapper: 'group-data-[selected=true]:border-black' }}>
                    No
                  </Radio>
                </RadioGroup>

                {extraControls.willDeliver === 'no' && (
                  <div className='mt-4'>
                    <label htmlFor='quantity' className='block mb-1'>¿Cuántos controles extra se entregan (Máximo 3)?</label>
                    <input
                      type='number'
                      id='quantity'
                      className='border rounded-md p-2 w-32'
                      value={extraControls.quantity}
                      onChange={(e) => setExtraControls({ ...extraControls, quantity: Number(e.target.value) })}
                      min={1}
                      max={3}
                    />
                  </div>
                )}
              </div>
              {/* <Switch
                isSelected={!discounts.isExtraControl} onValueChange={(value) => setDiscounts({ ...discounts, isExtraControl: !value })}
                classNames={{
                  base: cn(
                    'inline-flex flex-row-reverse w-full max-w-full bg-content1 hover:bg-content2 items-center',
                    'justify-between cursor-pointer rounded-lg gap-2 p-4 border-2 border-transparent',
                    'data-[selected=true]:border-primary'
                  ),
                  wrapper: 'p-0 h-4 overflow-visible',
                  thumb: cn('w-6 h-6 border-2 shadow-lg',
                    'group-data-[hover=true]:border-primary',
                    // selected
                    'group-data-[selected=true]:ml-6',
                    // pressed
                    'group-data-[pressed=true]:w-7',
                    'group-data-[selected]:group-data-[pressed]:ml-4'
                  )
                }}
              >
                <div className='flex flex-col gap-1'>
                  <p className='text-medium'>¿Se entrgan funcionando los controles extra ({ctx.tradein.extraControlsQuoted}) que se cottizaron?</p>
                </div>
              </Switch> */}
              <div
                hidden={!extraControls.willDeliver || extraControls.willDeliver === 'yes'}
                className='pt-2'
              >
                <NUIAlert type='warning'>Si continuas aplicas un {getInfoNewAmount()} a la cotizacion inicial</NUIAlert>
              </div>
              <div
                // hidden={discounts.isExtraControl}
                className='pt-2'
              >
                <NUIAlert type='info'>Para avanzar debe subir foto de la evidencia de los dos controles</NUIAlert>
                <div
                  {...getRootProps()} style={{
                    border: ctx.files.length > 0 ? '1px solid #ccc' : '1px dashed #ff8181',
                    borderRadius: '5px',
                    padding: '20px',
                    textAlign: 'center',
                    marginTop: '6px',
                    cursor: 'pointer',
                    backgroundColor: isDragActive ? '#cce5ff' : ctx.files.length > 0 ? '#fff' : '#ffefef',
                    color: isDragActive ? '#ffffff' : '#000000'
                  }}
                >
                  <input {...getInputProps()} />
                  {
                isDragActive
                  ? (
                    <p>Arrastra y suelta las imágenes aquí...</p>
                    )
                  : (
                    <div hidden={ctx.files.length > 0}>
                      <h4 className='font-extrabold'>Adjuntar imagen con los dos controles entrgados (Requerido)</h4>
                      <p>Arrastra y suelta la imagen aquí, o haz clic para seleccionar archivos</p>
                    </div>
                    )
              }
                  <p color='textSecondary' hidden={ctx.files.length > 0}>
                    (Solo se permiten archivos .png, .jpg y .jpeg)
                  </p>
                  <div className='grid grid-cols-1'>
                    {ctx.files.map((file, index) => (
                      <div key={index} className='max-w-44'>
                        <img src={URL.createObjectURL(file)} alt={`preview ${index}`} />
                        <p>{file.name}</p>
                        <Button color='danger' size='sm' onClick={(event: any) => removeFile(file, event)}>
                          Eliminar
                        </Button>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
            </div>
            )
          : null
      }

              {
        // Si no se ha cargado el detalle de los descuentos, no se muestra el boton
        ctx.tradein.haveCharger === null
          ? (
            <div
              hidden={ctx.tradein.isExtraControl === 1}
              className='mt-2'
            >
              <Button
                isLoading={data.loading}
                isDisabled={ctx.files.length === 0 || !extraControls.willDeliver || Number(extraControls.quantity) > 4}
                color='primary' onClick={uploadImage}
              >
                {ctx.tradein.sbu === 'Smartwatch' ? 'Enviar' : 'Continuar'}
              </Button>
            </div>
            )
          : null
      }

              {
        ctx.tradein.haveCharger !== null && ctx.tradein.sbu !== 'Smartphone'
          ? (
            <div className='p-4 bg-slate-100 border-1 border-slate-500 rounded-lg mb-2'>
              <p className='text-large font-bold'> {ctx.tradein.haveCharger === 1 ? 'Dispositivo se entrega con cargador' : 'Dispositivo se entrega sin cargador'} </p>
            </div>
            )
          : null
      }
              {
        ctx.tradein.isExtraControl !== null && data.imagen !== null && ctx.tradein.sbu !== 'Smartwatch'
          ? (

            <div className='p-4 bg-slate-100 border-1 border-slate-500 rounded-lg'>
              <p className='text-large pb-4 font-bold'> {ctx.tradein.isExtraControl === 1 ? 'Se entrego control extra' : 'No se entrego control extra'} </p>
              <img
                hidden={ctx.tradein.isExtraControl === 0}
                className={isSamsungPeru ? 'h-[400px]' : 'w-full'}
                src={`https://${import.meta.env.VITE_BUCKET}.s3.us-west-2.amazonaws.com/${configSeller.config.s3.FOLDER_APP}/imagenes/${id}/${data.imagen}`} alt={ctx.tradein.isExtraControl === 1 ? 'Mayor ó igual al 80%' : 'No supera el 80%'}
              />
            </div>
            )
          : ctx.tradein.isExtraControl === 1 && data.imagen === null
            ? (
              <div className='d-flex justify-content-center align-items-center h-100'>
                <div className='d-flex gap-2 align-items-center'>
                  <h6 className='m-0'>Evidencia de controles</h6>
                  {/* <p className='text-primary fw-bold m-0'>{ctx.tradein.batteryHealthPercentage}</p> */}
                </div>
              </div>
              )
            : null
      }

            </div>)
      }

    </div>
  )
}

export default Extras
